import React, { useState, useRef, useEffect } from 'react'
import Link from 'next/link'
import { Sparkles, ChevronDown } from 'lucide-react'
import { Button } from '@components/ui/button'

const CreateButton = ({ createOptions, handleButtonClick }) => {
  const [isOpen, setIsOpen] = useState(false)
  const buttonRef = useRef(null)
  const menuRef = useRef(null)
  const timeoutRef = useRef(null)

  // Function to handle mouse enter for both button and menu
  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = null
    }
    setIsOpen(true)
  }

  // Function to handle mouse leave with delay
  const handleMouseLeave = () => {
    // Add a delay before closing to allow mouse movement between button and menu
    timeoutRef.current = setTimeout(() => {
      setIsOpen(false)
    }, 300) // 300ms delay gives time to move mouse to dropdown
  }

  // Clean up timeout on unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [])

  return (
    <div className="relative">
      {/* Button that triggers the dropdown */}
      <div ref={buttonRef} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        <Button variant="gradient">
          <Sparkles size={16} />
          Create <ChevronDown size={14} className="ml-1" />
        </Button>
      </div>

      {/* Custom dropdown menu */}
      {isOpen && (
        <div
          ref={menuRef}
          className="absolute right-0 mt-1 w-36 bg-white border border-gray-200 rounded-md shadow-lg  z-[999999999]"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          {createOptions.map((option, index) =>
            option.href ? (
              <Link key={`create-option-${index}`} href={option.href} passHref>
                <div
                  className={`flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-gray-100 ${index === 0 ? 'rounded-t-md' : ''}  ${index === createOptions.length - 1 ? 'rounded-b-md' : ''}`}
                >
                  {option.icon && React.createElement(option.icon, { className: 'w-4 h-4' })}
                  <span>{option.label}</span>
                </div>
              </Link>
            ) : (
              <div
                key={`create-option-${index}`}
                className="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-gray-100"
                onClick={() => {
                  handleButtonClick(option)
                  setIsOpen(false)
                }}
              >
                {option.icon && React.createElement(option.icon, { className: 'w-4 h-4' })}
                <span>{option.label}</span>
              </div>
            )
          )}
        </div>
      )}
    </div>
  )
}

export default CreateButton
